module.exports = __webpack_public_path__ + "img/videoDeactive.1a28acab.png";